// src/layout/Dashboard/Drawer/DrawerContent/Navigation/index.jsx
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import NavGroup from './NavGroup';
import { useMenuItems } from 'menu-items';

export default function Navigation() {
  const { menuItems, loading, error } = useMenuItems();

  if (loading) {
    return <Box sx={{ pt: 2, px: 3 }}><Typography variant="body2">Cargando menú…</Typography></Box>;
  }
  if (error) {
    return <Box sx={{ pt: 2, px: 3 }}><Typography color="error">No se pudo cargar el menú.</Typography></Box>;
  }

  const navGroups = (menuItems.items || []).map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
